import React, { Fragment as F } from 'react'
import c from 'classnames'
import { connect } from 'react-redux'

import { NavbarLink } from './NavLink'
import { Link } from 'redux-little-router'

import { getIsLoggedIn, getRooftopOptions } from 'selectors/authSelectors'
import ExactMatchSearch from 'pages/inventory/ExactMatchSearch.js'

import {
  getTheme,
  getRooftopName,
  getRooftopSalesPhone,
} from 'selectors/appStatusSelectors'

import {
  getActivePathname,
  getActiveRouteName,
  getRouteWithRooftop,
  getQueryValue,
  isAuthRoute,
} from 'selectors/pageStateSelectors'

import { setPageTitle, goToRootPath } from 'actions/pageStateActions'
import { formatPhone } from 'utils'

import { ROOTS, NAV_ROUTES, createNavFilter } from 'pages/routes'

import './index.scss'

const importAll = r => r.keys().map(r)
const logos = importAll(require.context('static/images/oemLogos')).reduce(
  (ret, l) => {
    return {
      ...ret,
      [l
        .split('/')
        .slice(-1)[0]
        .split('.')[0]]: l,
    }
  },
  {},
)

export class Nav extends React.Component {
  constructor(...args) {
    super(...args)

    this.state = {
      isActive: false,
    }

    this.toggleActive = () => this.setState({ isActive: !this.state.isActive })
    this.closeNav = () => this.setState({ isActive: false })
    this.setPageScrollPosition = () => {
      document.body.scrollTop = document.documentElement.scrollTop = 0
    }
  }

  componentDidUpdate(prevProps) {
    prevProps.pathname !== this.props.pathname && this.setPageScrollPosition()
  }

  static getDerivedStateFromProps({ isLoggedIn }) {
    return { isLoggedIn }
  }

  render() {
    let {
        className,
        scrub,
        theme,
        rooftopName,
        defaultRoute,
        isLoggedIn,
        isSimple,
        rooftopPhone,
        noShow,
        isAuthRoute,
      } = this.props,
      { isActive } = this.state,
      navFilter = createNavFilter(NAV_ROUTES, this.props),
      mainNav = Object.keys(NAV_ROUTES)
        .filter(navFilter)
        .filter(k => NAV_ROUTES[k].showInMainNav),
      utilNav = Object.keys(NAV_ROUTES)
        .filter(navFilter)
        .filter(k => NAV_ROUTES[k].showInUtilNav),
      navMapper = k => (
        <NavbarLink
          key={k}
          {...NAV_ROUTES[k]}
          pathname={k}
          scrub={scrub}
          onClick={this.closeNav}
          className="main-nav-item"
        />
      )

    isSimple = isSimple && !isLoggedIn

    if (noShow) return null

    if (!rooftopName || isAuthRoute) {
      return <>{/* nada */}</>
    }

    return (
      <nav
        className={c('navbar', 'is-fixed-top', className, {
          'is-simple': isSimple,
        })}
        aria-label="main navigation"
      >
        <div className="navbar-brand">
          <Link
            href={scrub(defaultRoute)}
            className="navbar-item nav-logo"
            onClick={e => isSimple && e.preventDefault()}
          >
            <img src={logos[theme] || logos.generic} alt="IllumiQuote" />
            <span className="rooftop-info-wrapper">
              <strong>{rooftopName}</strong>
              {rooftopPhone && (
                <strong className="sales-phone">
                  Call us! <span>{formatPhone(rooftopPhone)}</span>{' '}
                </strong>
              )}
            </span>
          </Link>

          <span
            role="button"
            className={c('navbar-burger', { 'is-active': isActive })}
            aria-label="menu"
            aria-expanded="false"
            onClick={this.toggleActive}
          >
            <span aria-hidden="true" />
            <span aria-hidden="true" />
            <span aria-hidden="true" />
          </span>
        </div>

        {!isSimple && (
          <F>
            <div className={c('navbar-menu', { 'is-active': isActive })}>
              <div className="navbar-start">
                {mainNav.map(navMapper)}
                <ExactMatchSearch />
                {utilNav.map(navMapper)}
              </div>
            </div>
          </F>
        )}
      </nav>
    )
  }
}

function mapStateToProps(state, op) {
  return {
    ...op,
    theme: getTheme(state),
    rooftopName: getRooftopName(state),
    pathname: getActivePathname(state),
    activeRouteName: getActiveRouteName(state),
    scrub: route => getRouteWithRooftop(state, route),
    defaultRoute: Object.keys(ROOTS).find(r => ROOTS[r].default),
    isLoggedIn: getIsLoggedIn(state),
    isSimple: getQueryValue(state, 'nav'),
    rooftopPhone: getRooftopSalesPhone(state),
    rooftopOptions: getRooftopOptions(state),
    isAuthRoute: isAuthRoute(state),
  }
}

export default connect(
  mapStateToProps,
  { setPageTitle, goToRootPath },
)(Nav)
